// extracted by mini-css-extract-plugin
export default {"sponsor":"SponsorItem_sponsor__OZPCZ","img":"SponsorItem_img__3gIFZ"};